import { ErrorBoundaryFallback } from './ErrorBoundaryFallback'
export default ErrorBoundaryFallback
